import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { BASE_URL } from "../config";
const PORTFOLIO_API = `${BASE_URL}/portfolio.php`;

const Portfolio = () => {
  const location = useLocation();

  const [data, setData] = useState({
    Mobile: [],
    Web: [],
    UIUX: [],
  });

  const [category, setCategory] = useState("Mobile");

  const [showAll, setShowAll] = useState(false);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");

  const [lightbox, setLightbox] = useState({
    open: false,
    images: [],
    index: 0,
  });

  // =========================================================
  // FETCH PORTFOLIO FROM PHP
  // =========================================================

  // =========================================================
  // FETCH PORTFOLIO FROM PHP
  // =========================================================

  useEffect(() => {
    let cancelled = false;

    const fetchPortfolio = async () => {
      try {
        setLoading(true);
        setError("");

        const url = `${PORTFOLIO_API}?action=get_projects`;

        console.log("Fetching Portfolio:", url);

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        console.log("Portfolio HTTP Status:", response.status);

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const result = await response.json();

        console.log("Portfolio API Response:", result);

        if (result.status !== "success") {
          throw new Error(
            result.message || "Unable to load portfolio projects.",
          );
        }

        // =====================================================
        // SUPPORT BOTH:
        // result.data
        // result.projects
        // =====================================================

        const projects = Array.isArray(result.data)
          ? result.data
          : Array.isArray(result.projects)
            ? result.projects
            : [];

        console.log("Portfolio Projects:", projects);

        const groupedData = {
          Mobile: [],
          Web: [],
          UIUX: [],
        };

        // =====================================================
        // GROUP PROJECTS
        // =====================================================

        projects.forEach((project) => {
          const projectCategory = String(project.category || "Mobile").trim();

          // Make sure category exists
          if (!groupedData[projectCategory]) {
            groupedData[projectCategory] = [];
          }

          // ===================================================
          // IMAGES
          // ===================================================

          const rawImages = Array.isArray(project.images) ? project.images : [];

          const images = rawImages
            .map((item) => {
              if (typeof item === "string") {
                return getImageUrl(item);
              }

              if (item && typeof item === "object") {
                return getImageUrl(item.image);
              }

              return "";
            })
            .filter(Boolean);

          console.log(`Project "${project.title}" images:`, images);

          groupedData[projectCategory].push({
            id: project.id,
            title: project.title || "",

            category: projectCategory,
            images,
            link: project.app_link || "",
            display_order: Number(project.display_order) || 0,
          });
        });

        // =====================================================
        // SORT BY DISPLAY ORDER
        // =====================================================

        Object.keys(groupedData).forEach((key) => {
          groupedData[key].sort(
            (a, b) => Number(a.display_order) - Number(b.display_order),
          );
        });

        console.log("Grouped Portfolio:", groupedData);

        if (!cancelled) {
          setData(groupedData);
        }
      } catch (err) {
        console.error("Portfolio API Error:", err);

        if (!cancelled) {
          setError(err.message || "Failed to load portfolio.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchPortfolio();

    return () => {
      cancelled = true;
    };
  }, []);

  // =========================================================
  // IMAGE URL
  // =========================================================

  // =========================================================
  // IMAGE URL
  // =========================================================

  const getImageUrl = (image) => {
    if (!image) {
      return "";
    }

    const imagePath = String(image).trim();

    if (!imagePath) {
      return "";
    }

    return `https://lifetimeinfotech.in/backend/portfolio_uploads/${imagePath}`;
  };

  useEffect(() => {
    AOS.refreshHard();
  }, [category, data]);

  const openLightbox = (images, index = 0) => {
    setLightbox({
      open: true,
      images,
      index,
    });
  };

  const closeLightbox = () => {
    setLightbox({
      open: false,
      images: [],
      index: 0,
    });
  };

  const nextImage = () => {
    setLightbox((prev) => ({
      ...prev,

      index: (prev.index + 1) % prev.images.length,
    }));
  };

  const prevImage = () => {
    setLightbox((prev) => ({
      ...prev,

      index: (prev.index - 1 + prev.images.length) % prev.images.length,
    }));
  };

  // =========================================================
  // KEYBOARD CONTROL
  // =========================================================

  useEffect(() => {
    const handleKey = (e) => {
      if (!lightbox.open) {
        return;
      }

      if (e.key === "ArrowRight") {
        nextImage();
      }

      if (e.key === "ArrowLeft") {
        prevImage();
      }

      if (e.key === "Escape") {
        closeLightbox();
      }
    };

    window.addEventListener("keydown", handleKey);

    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, [lightbox]);

  // =========================================================
  // HASH CATEGORY
  // =========================================================

  useEffect(() => {
    if (location.hash) {
      const hash = location.hash.replace("#", "").toLowerCase();

      if (hash === "mobile") {
        setCategory("Mobile");
      }

      if (hash === "web") {
        setCategory("Web");
      }

      if (hash === "uiux") {
        setCategory("UIUX");
      }
    }
  }, [location]);

  // =========================================================
  // RESET SHOW ALL
  // =========================================================

  useEffect(() => {
    setShowAll(false);
  }, [category]);

  // =========================================================
  // BODY SCROLL
  // =========================================================

  useEffect(() => {
    document.body.style.overflow = lightbox.open ? "hidden" : "unset";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [lightbox.open]);

  // =========================================================
  // LOADING
  // =========================================================

  if (loading) {
    return (
      <section className="p-folio">
        <div className="p-folio__hero">
          <h1 className="p-folio__title">Our Global Portfolio</h1>

          <p className="p-folio__subtitle">Loading portfolio...</p>
        </div>
      </section>
    );
  }

  // =========================================================
  // ERROR
  // =========================================================

  if (error) {
    return (
      <section className="p-folio">
        <div className="p-folio__hero">
          <h1 className="p-folio__title">Our Global Portfolio</h1>

          <p className="p-folio__subtitle">{error}</p>
        </div>
      </section>
    );
  }

  // =========================================================
  // CURRENT CATEGORY
  // =========================================================

  const currentData = data[category] || [];

  const visibleData = showAll ? currentData : currentData.slice(0, 12);

  return (
    <section className="p-folio">
      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="p-folio__hero" data-aos="fade-down">
        <h1 className="p-folio__title">Our Global Portfolio</h1>

        <p className="p-folio__subtitle">
          A fine presentation of modern engineering, innovative interfaces, and
          functional designs.
        </p>

        {/* ===================================================
            CATEGORY TABS
        =================================================== */}

        <div className="p-folio__tabs">
          {["Mobile", "Web", "UIUX"].map((tab) => (
            <button
              key={tab}
              className={`p-folio__tab-btn ${
                category === tab ? "is-active" : ""
              }`}
              onClick={() => setCategory(tab)}
            >
              {tab === "UIUX"
                ? "UI/UX Concept"
                : tab === "Web"
                  ? "Web Development"
                  : "Mobile Apps"}
            </button>
          ))}
        </div>
      </div>

      {/* =====================================================
          PORTFOLIO GRID
      ===================================================== */}

      <div className="p-folio__grid" key={category}>
        {visibleData.length === 0 ? (
          <div className="p-folio__empty">No portfolio projects available.</div>
        ) : (
          visibleData.map((item, index) => {
            const mainImage =
              item.images && item.images.length > 0 ? item.images[0] : "";

            return (
              <div
                className="p-folio__card"
                key={item.id}
                data-aos="zoom-in-up"
              >
                {/* =================================================
                      IMAGE
                  ================================================= */}

                <div
                  className="p-folio__card-media"
                  onClick={() =>
                    item.images.length > 0 && openLightbox(item.images, 0)
                  }
                >
                  {mainImage ? (
                    <img
                      src={mainImage}
                      alt={item.title}
                      className="p-folio__card-img"
                    />
                  ) : (
                    <div className="p-folio__no-image">No Image</div>
                  )}

                  <div className="p-folio__card-overlay">
                    <span className="p-folio__card-zoom-icon">
                      🔍 View Showcase
                    </span>
                  </div>

                  {/* =============================================
                        IMAGE NAVIGATION
                    ============================================= */}

                  {item.images.length > 1 && (
                    <div className="p-folio__card-gallery-nav">
                      <button
                        className="p-folio__card-nav-arrow"
                        onClick={(e) => {
                          e.stopPropagation();

                          openLightbox(item.images, 0);
                        }}
                      >
                        ❮
                      </button>

                      <button
                        className="p-folio__card-nav-arrow"
                        onClick={(e) => {
                          e.stopPropagation();

                          openLightbox(item.images, 1);
                        }}
                      >
                        ❯
                      </button>
                    </div>
                  )}
                </div>

                {/* =================================================
                      DETAILS
                  ================================================= */}

                <div className="p-folio__card-details">
                  <h3 className="p-folio__card-title">{item.title}</h3>

                  {category !== "UIUX" && item.link && item.link !== "#" && (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-folio__card-cta"
                    >
                      {category === "Mobile" ? "Install →" : "Visit →"}
                    </a>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* =====================================================
          SHOW MORE
      ===================================================== */}

      {currentData.length > 12 && (
        <div className="p-folio__footer-actions">
          <button
            className="p-folio__load-btn"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show Less ↑" : "Show More ↓"}
          </button>
        </div>
      )}

      {/* =====================================================
          LIGHTBOX
      ===================================================== */}

      {lightbox.open &&
        createPortal(
          <div className="p-folio-modal" onClick={closeLightbox}>
            <button className="p-folio-modal__dismiss" onClick={closeLightbox}>
              ✕ Close
            </button>

            <div
              className="p-folio-modal__wrapper"
              onClick={(e) => e.stopPropagation()}
            >
              {/* LEFT */}

              {lightbox.index > 0 && (
                <button
                  className="p-folio-modal__nav p-folio-modal__nav--left"
                  onClick={prevImage}
                >
                  ❮
                </button>
              )}

              {/* IMAGE */}

              <div className="p-folio-modal__screen">
                <img
                  src={lightbox.images[lightbox.index]}
                  alt="Showcase detail presentation"
                  className="p-folio-modal__viewport-img"
                />
              </div>

              {/* RIGHT */}

              {lightbox.index < lightbox.images.length - 1 && (
                <button
                  className="p-folio-modal__nav p-folio-modal__nav--right"
                  onClick={nextImage}
                >
                  ❯
                </button>
              )}
            </div>

            <div className="p-folio-modal__counter">
              Project Image {lightbox.index + 1} of {lightbox.images.length}
            </div>
          </div>,

          document.body,
        )}
    </section>
  );
};

export default Portfolio;
